import { B2Breadcrumb, B2Button } from "@hdb/biome-2";
import { FC } from "react";
import { BreadCrumbInfoModel } from "../../../shared/models/breadCrumbInfo.model";

interface BreadcrumbProps {
  breadCrumbInfo: BreadCrumbInfoModel[];
  buttonConfig?: any;
}

const BreadcrumbComponent: FC<BreadcrumbProps> = ({
  breadCrumbInfo,
  buttonConfig = null,
}) => {
  return (
    <div>
      <B2Breadcrumb menuList={breadCrumbInfo} />

      {buttonConfig ? (
        <div>
          <B2Button
            variant="primary"
            className="d-block ms-auto"
            onClick={() => {
              buttonConfig.event();
            }}
          >
            {buttonConfig.title}
          </B2Button>
        </div>
      ) : null}
    </div>
  );
};

export default BreadcrumbComponent;
